import React from 'react';
import PropTypes from 'prop-types';
import LiveTile from './views/LiveTile';
import SearchTile from './views/SearchTile';
import FindTile from './views/FindTile';
import EpisodeTile from './views/EpisodeTile';
import { EpisodeProcessor, TileProcessor } from './processors';

const LIVE_TILE = 'live';
const SEARCH_TILE = 'search';
const FIND_TILE = 'find';
const EPISODE_TILE = 'episode';

const getProcessor = type => {
  switch (type) {
    case EPISODE_TILE:
      return EpisodeProcessor;

    default:
      return TileProcessor;
  }
};

const Tile = ({ type, ...rest }) => {
  const components = {
    [LIVE_TILE]: LiveTile,
    [SEARCH_TILE]: SearchTile,
    [FIND_TILE]: FindTile,
    [EPISODE_TILE]: EpisodeTile,
  };
  const Component = components[type];
  if (!type) return null;
  return <Component processor={getProcessor(type)} {...rest} />;
};

Tile.propTypes = { type: PropTypes.string.isRequired };

// eslint-disable-next-line import/no-unused-modules
export { Tile, LIVE_TILE, SEARCH_TILE, FIND_TILE, EPISODE_TILE };
